export enum LicensesEvent {
    ClickedStartTrial = 'Licenses.ClickedStartTrial',
    ClickedStartTrialClickedStartTrial = 'Licenses.ClickedStartTrialClickedStartTrial',
    ClickedStartTrialClickedStartTrialError = 'Licenses.ClickedStartTrialClickedStartTrialError',
}
